export { withSizeL } from './_size/Textinput_size_l';
